import React from 'react'
import {Motion, spring} from 'react-motion'
import range from 'lodash/range'
import debounce from 'lodash/debounce'
import { ContextMenuTrigger } from 'react-contextmenu'
import StaticQuestionSlide from '../slides/StaticQuestionSlide'
import PerfectScrollbar from 'react-perfect-scrollbar'


const ITEM_HEIGHT = 102
const SLIDE_WIDTH = 140
const springConfig = {stiffness: 450, damping: 30}
const DND_DELAY = 150

function reinsert(arr, from, to) {
	const _arr = arr.slice(0)
	const val = _arr[from]
	_arr.splice(from, 1)
	_arr.splice(to, 0, val)
	return _arr
}

function clamp(n, min, max) {
	return Math.max(Math.min(n, max), min)
}

class QuestionListPanel extends React.Component {
    
	constructor(props) {
		super(props)
		this.state = {
			topDeltaY: 0,
			mouseY: 0,
			isPressed: false,
			originalPosOfLastPressed: 0,
			currentRow:0,
			order: range(props.questionList.length),
			questions:props.questionList,
			activeQuestion:props.activeQuestion,
			contextMenuVisible:false,
			mouseDown:false,
			checkIfReordered:false
		}

		this.handleMouseMove=this.handleMouseMove.bind(this)
		this.handleMouseDown=this.handleMouseDown.bind(this)
		this.delayedMouseDown=this.delayedMouseDown.bind(this)
		this.handleMouseUp=this.handleMouseUp.bind(this)
		this.delayedMouseDown = debounce(this.delayedMouseDown,DND_DELAY)
	}

	componentDidMount() {
		window.addEventListener('mousemove', this.handleMouseMove)
		window.addEventListener('mouseup', this.handleMouseUp)
		window.addEventListener('keydown', this.props.handleQuestionListKeyDown)
		const card=document.getElementById(this.props.activeQuestion.questionId)
		card.focus()
	}

	componentWillUnmount() {
		window.removeEventListener('mousemove', this.handleMouseMove)
		window.removeEventListener('mouseup', this.handleMouseUp)  
		window.removeEventListener('keydown', this.props.handleQuestionListKeyDown)
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(nextProps !==this.props){
			if(nextProps.questionList){
				this.setState({
					order:range(nextProps.questionList.length),
					questions:nextProps.questionList, 
					activeQuestion:nextProps.activeQuestion
				})
			}
		}
	}

	componentDidUpdate(prevProps){

		if(this.props.activeQuestionIndex!==prevProps.activeQuestionIndex){
			const card=document.getElementById(this.props.activeQuestion.questionId)
			card.focus()
		}
	}

	delayedMouseDown(pos, pressY,pageY){     
		if(this.state.mouseDown){
			this.setState({
				topDeltaY: pageY - pressY,
				mouseY: pressY,
				isPressed: true,
				originalPosOfLastPressed: pos,
				currentRow:pos,
				selectedQuestionIndex:pos,
				checkIfReordered:true
			})
		}
	}



	handleMouseDown(pos, pressY,e){
		if(!this.props.isViewOnly && !this.props.itemIsLockedByAnotherUser){
			this.setState({mouseDown:true})
			if(!this.state.contextMenuVisible){
				if(e.button !==2){
			  	const {pageY}=e
					this.delayedMouseDown(pos, pressY,pageY)
				}	
			}
		}			
		this.props.selectQuestionCard(this.state.questions[pos])

	}



	handleMouseMove({pageY}){
		const {isPressed, topDeltaY, order, originalPosOfLastPressed,questions} = this.state
		if (isPressed) {
			this.props.lockItem()
			const mouseY = pageY - topDeltaY
			const currentRow = clamp(Math.round(mouseY / ITEM_HEIGHT), 0, questions.length - 1)
			let newOrder = order
			if (currentRow !== order.indexOf(originalPosOfLastPressed)){
				newOrder = reinsert(order, order.indexOf(originalPosOfLastPressed), currentRow)	
			}
			this.setState({mouseY: mouseY, order: newOrder, currentRow:currentRow})
		}
	}




	handleMouseUp(){
		this.setState({isPressed: false, topDeltaY: 0,mouseDown:false})
		if(this.state.checkIfReordered){
			if(this.state.originalPosOfLastPressed !== this.state.currentRow){
				const oldQuestionArray=this.state.questions
				let newQuestionArray=[]
				this.state.order.map(pos => {
					newQuestionArray.push(oldQuestionArray[pos])
					return null
				})

				this.props.updateOrder(newQuestionArray)

				this.setState({
					questions:newQuestionArray,
					order: range(newQuestionArray.length),
					checkIfReordered:false
				})

			}
		}
	}

	collect(props) {
		return { question:props.question}
	}


	render() {
		const {mouseY, isPressed, originalPosOfLastPressed, order} = this.state    
				
		return (				
			<div className={'itemEditor-questionList ' + (this.props.itemIsLockedByAnotherUser ? 'itemEditor-questionList--lockedByAnotherUser' : '')} key='list'>

		    <PerfectScrollbar
		    option={{
		    		handlers:['click-rail', 'drag-thumb', 'wheel', 'touch'],
		    		suppressScrollX: true
		    	}}		    	
		    >
								
					<div className='itemEditor-questionList-topSpacer' />
						
					{range(this.state.questions.length).map(i => {
						const question=this.state.questions[i]
						const style = originalPosOfLastPressed === i && isPressed
							? {	
								scale: spring(1.18, springConfig),
								shadow: spring(4, springConfig),
								y: mouseY,
							}
							: {
								scale: spring(1, springConfig),
								shadow: spring(0.25, springConfig),
								y: spring(order.indexOf(i) * ITEM_HEIGHT, springConfig),
							}

						let cardActive=false 
						let tabIndex=-1         
						if(i===parseInt(this.props.activeQuestionIndex,10)){
							cardActive=true
							tabIndex=1            
						}

						let zIndexStatic 

						if(isPressed){
							zIndexStatic = 99
						}
						else{
							zIndexStatic = i
						}


						return (       
							<ContextMenuTrigger 
								id='QUESTION_SLIDE'
								key={this.state.questions[i].questionId || [i]}
								disable={this.state.isPressed}
								holdToDisplay={-1}
								collect={this.collect}
								question={this.state.questions[i]}
							>

								<Motion style={style} key={this.state.questions[i].questionId}>
									{({scale, shadow, y}) =>
										<div
											className={'tabbable itemEditor-questionList-slideItem u--unselectable' + (cardActive ? ' is-active':' is-notactive') + (cardActive ? ' tab-test':' ') + (isPressed ? ' is-pressed':'') + (scale < 1.03 ? ' is-atRest':' is-notatRest')}
											key={this.state.questions[i].questionId}
											id={this.state.questions[i].questionId}
											tabIndex={tabIndex}
											onMouseDown={this.handleMouseDown.bind(null, i, y)} 
											onKeyDown={this.props.handleQuestionCardKeyDown}
											style={{                    
												transform: `translate3d(0, ${y}px, 0)`,  
												zIndex: i === originalPosOfLastPressed ? zIndexStatic : i,
											}}>  

											<div className='itemEditor-questionList-slideItem-indexNumber' key={i}>
												{order.indexOf(i) + 1}
											</div>

											<div 
												key={this.state.questions[i].questionId}
												className={'itemEditor-questionList-slideItem-slide'}
												style={{
													transform: `scale(${scale})`,  
													boxShadow: `rgba(0, 0, 0, 0.2) 0px ${shadow}px ${3 * shadow}px 0px`,
												}} >  
											               
												<StaticQuestionSlide 
													question={question} 
													questionBody={question.body}
													choice1Body={question.choices[0].body}
													choice2Body={question.choices[1].body}
													choice3Body={question.choices[2] ? question.choices[2].body:null}
													choice4Body={question.choices[3] ? question.choices[3].body:null}
													image={question.image}
													template={question.template}
												 	displayWidth={SLIDE_WIDTH} key={i}
												 />																					 
											</div>   
										</div>
									}
								</Motion> 
          	</ContextMenuTrigger>  
          	)
	      })}	      
				</PerfectScrollbar>
			</div>			
		)
	}
}

 
export default QuestionListPanel